import React from 'react';
import {Text, Button} from 'wix-ui-tpa/cssVars';
import Replace from 'wix-ui-icons-common/on-stage/Replace';
import {classes} from './ErrorState.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';

export enum ErrorStateDataHooks {
  Title = 'ErrorStateDataHooks.Title',
  Subtitle = 'ErrorStateDataHooks.Subtitle',
  RefreshButton = 'ErrorStateDataHooks.RefreshButton',
}

interface ErrorStateProps {
  dataHook: string;
  title?: string;
  subtitle?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = (props: ErrorStateProps) => {
  const {dataHook, title, subtitle} = props;
  const localeKeys = useLocaleKeys().checkout.couldntLoadError;

  return (
    <div data-hook={dataHook} className={classes.root}>
      <Text data-hook={ErrorStateDataHooks.Title} className={classes.title}>
        {title ?? localeKeys.title()}
      </Text>
      <Text data-hook={ErrorStateDataHooks.Subtitle} className={classes.subtitle}>
        {subtitle ?? localeKeys.subtitle()}
      </Text>

      <Button
        data-hook={ErrorStateDataHooks.RefreshButton}
        className={classes.button}
        prefixIcon={<Replace />}
        onClick={() => window.location.reload()}>
        {localeKeys.cta()}
      </Button>
    </div>
  );
};
